import { useDispatch } from 'react-redux';
import { CloseIcon } from '../../assets/icons/Svg';
import { clearTypeOfShowModalType, setTypeOfShowModalType } from '../../features/modal/modalSlice';
import Loading from '../ui/Loading';
import { useGetUserInitial } from '../../hooks/useGetUserInitial';
import { useQueryData } from '../../hooks/api/useQueryData';
import { useStaffMeta } from '../../hooks/useStaffMeta';
import { useStaffPopulate } from '../../hooks/populate/useStaffPopulate';

export default function ProfileDetails() {

    const dispatch = useDispatch();
    const userInitial = useGetUserInitial()
    const { userInfo, isErrorUserInfo, isLoadingUserInfo } = useQueryData()
    const { roles, status } = useStaffMeta();
    const { populateStaffInfo } = useStaffPopulate(userInfo, roles, status);

    const handleCloseProfileDetails = () => {
        dispatch(clearTypeOfShowModalType());
    }

    const handleUpdateProfile = () => {
        populateStaffInfo();
        dispatch(setTypeOfShowModalType("viewAndUpdateUserDetails"))
    }

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[75%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[50%] lg:max-w-[30%] lg:mx-auto'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-base items-start font-semibold leading-tight text-slate-900">
                                    Profile
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    onClick={handleCloseProfileDetails}
                                >
                                    <CloseIcon/>
                                </button>
                            </div>
                        </div>
                        <>
                            { isLoadingUserInfo ? (
                                <Loading message='Loading...'/>
                            ) : isErrorUserInfo ? (
                                <div className='pb-10 px-2 flex text-center items-center justify-center h-full'>Failed to fetch data. Please try again.</div>
                            ) : (
                                <>
                                    <div className="flex flex-col items-center mt-3">
                                        <div className="w-20 h-20 rounded-full bg-cbColor text-white text-3xl flex items-center justify-center shadow-md">
                                            {userInitial}
                                        </div>
                                        <p className="mt-1.5 text-xl font-semibold text-gray-800">
                                            {`${userInfo?.firstName} ${
                                                userInfo?.middleInitial ? userInfo?.middleInitial + ". " : ""
                                            }${userInfo?.lastName}`}
                                        </p>
                                        <p className="text-sm text-gray-500">{userInfo?.email}</p>
                                        <span className="mt-1 text-xs px-3 py-1 rounded-full bg-green-100 text-green-700 font-medium">
                                            {userInfo?.statusId === 1 ? "Active" : "Inactive"}
                                        </span>
                                    </div>

                                    <div className="mt-3.5 space-y-1.5">
                                        <div className="flex justify-between">
                                            <span className="text-sm text-gray-500">Role</span>
                                            <span className="text-sm font-medium text-gray-800">
                                            {userInfo?.roleName ?? "Super Admin"}
                                            </span>
                                        </div>

                                        <div className="flex justify-between">
                                            <span className="text-sm text-gray-500">Email</span>
                                            <span className="text-sm font-medium text-gray-800">
                                                {userInfo?.email}
                                            </span>
                                        </div>

                                        <div className="flex justify-between">
                                            <span className="text-sm text-gray-500">Status</span>
                                            <span className="text-sm font-medium text-gray-800">
                                                {userInfo?.statusId === 1 ? "Active" : "Inactive"}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="mt-3 pt-2.5 border-t flex justify-end">
                                        <button 
                                            onClick={handleUpdateProfile}
                                            className="w-full px-5 py-2 bg-cbColor text-white rounded text-sm font-medium transition"
                                        >
                                            Update Profile
                                        </button>
                                    </div>
                                </>
                            )}
                        </>
                    </div>
                </div>
            </div>
        </div>
    )
}
